<template>
	<div class="omapi-text-select-input">
		<label
			>{{ label }}
			<input type="text" :value="input" :disabled="disabled" @input="$emit('input', $event.target.value)"
		/></label>
	</div>
</template>

<script>
export default {
	name: 'TextInput',
	props: {
		label: {
			type: String,
			default: '',
		},
		disabled: {
			type: Boolean,
			default: false,
		},
		input: {
			type: String,
			default: '',
		},
	},
};
</script>
